"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetLinkedAssetsBase = void 0;
const Entities_1 = require("../../Entities");
class GetLinkedAssetsBase extends Entities_1.RequestHandler {
    castPayloadV1(payload) {
        const castPayload = payload;
        if (!castPayload.assetID || !castPayload.callback || !castPayload.type) {
            throw new Entities_1.UnableToParsePayload(this.requestType, 1, JSON.stringify(payload));
        }
        return castPayload;
    }
    constructor(hostHandler) {
        super();
        this.requestType = 'GET_LINKED_ASSETS';
        this.action = () => {
            throw new Entities_1.ActionNotImplemented(this.requestType);
        };
        this.handleRequest = (version, payload) => {
            if (version === 1) {
                const { assetID, callback, type } = this.castPayloadV1(payload);
                this.action(assetID, type, callback);
            }
            else {
                throw new Entities_1.UnsupportedRequestVerion(this.requestType, version);
            }
        };
        hostHandler.registerRequestHandler(this);
    }
}
exports.GetLinkedAssetsBase = GetLinkedAssetsBase;
